(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('AeropuertoDialogController', AeropuertoDialogController);

    AeropuertoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Aeropuerto', 'Comercio', 'Provincia'];

    function AeropuertoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Aeropuerto, Comercio, Provincia) {
        var vm = this;

        vm.aeropuerto = entity;
        vm.clear = clear;
        vm.save = save;
        vm.comercios = Comercio.query();
        vm.provincias = Provincia.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.aeropuerto.id !== null) {
                Aeropuerto.update(vm.aeropuerto, onSaveSuccess, onSaveError);
            } else {
                Aeropuerto.save(vm.aeropuerto, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:aeropuertoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
